export const TENANT_ALL_ON_BOARDING_REDUCER_NAME = 'allOnBoarding'
export const TENANT_ALL_IDENTITY_PROVIDER_ID_REDUCER_NAME = 'allIdentityProviderId'
